module.exports = __webpack_public_path__ + "img/SKMJ_checkk1.7ad901ab.jpg";